<div class="kt-card max-w-[370px] w-full mx-auto">
  <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()" class="kt-card-content flex flex-col gap-5 p-10">
    <div class="text-center mb-2.5">
      <h3 class="text-lg font-medium text-mono leading-none mb-2.5">Sign up</h3>
      <div class="flex items-center justify-center">
        <span class="text-sm text-secondary-foreground me-1.5">Already have an Account ?</span>
        <a class="text-sm link" routerLink="/auth/sign-in">Sign In</a>
      </div>
    </div>
    
    <div class="grid grid-cols-2 gap-2.5">
      <a class="kt-btn kt-btn-outline justify-center" href="javascript:void(0)">
        <img alt="" class="size-3.5 shrink-0" src="/assets/media/brand-logos/google.svg"/> Google
      </a>
      <a class="kt-btn kt-btn-outline justify-center" href="javascript:void(0)">
        <img alt="" class="size-3.5 shrink-0 dark:hidden" src="/assets/media/brand-logos/apple-black.svg"/>
        <img alt="" class="size-3.5 shrink-0 light:hidden" src="/assets/media/brand-logos/apple-white.svg"/> Apple
      </a>
    </div>
    
    <div class="flex items-center gap-2">
      <span class="border-t border-border w-full"></span>
      <span class="text-xs text-secondary-foreground uppercase">or</span>
      <span class="border-t border-border w-full"></span>
    </div>

    @if (errorMessage) {
      <div class="text-red-500 text-sm italic text-center">
        {{ errorMessage }}
      </div>
    }

    <div class="flex flex-col gap-1">
      <label class="kt-form-label text-mono">Username</label>
      <input class="kt-input" formControlName="username" placeholder="Username" type="text"
             [ngClass]="{'border-red-500': signUpForm.get('username')?.touched && signUpForm.get('username')?.invalid}"/>
      @if (signUpForm.get('username')?.touched && signUpForm.get('username')?.invalid) {
        <span class="text-xs text-red-500">Username is required</span>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label class="kt-form-label text-mono">Email</label>
      <input class="kt-input" formControlName="email" placeholder="email@email.com" type="text"
             [ngClass]="{'border-red-500': signUpForm.get('email')?.touched && signUpForm.get('email')?.invalid}"/>
      @if (signUpForm.get('email')?.touched && signUpForm.get('email')?.invalid) {
         <span class="text-xs text-red-500">Valid email is required</span>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">Password</label>
      <div class="kt-input" [ngClass]="{'border-red-500': signUpForm.get('password')?.touched && signUpForm.get('password')?.invalid}">
        <input formControlName="password" placeholder="Enter Password" [type]="passwordVisible ? 'text' : 'password'"/>
        <button class="kt-btn kt-btn-sm kt-btn-ghost kt-btn-icon bg-transparent! -me-1.5"
                type="button" (click)="togglePasswordVisibility('password')">
          @if (!passwordVisible) {
            <span><i class="ki-filled ki-eye text-muted-foreground"></i></span>
          } @else {
            <span><i class="ki-filled ki-eye-slash text-muted-foreground"></i></span>
          }
        </button>
      </div>
      @if (signUpForm.get('password')?.touched && signUpForm.get('password')?.hasError('minlength')) {
        <span class="text-xs text-red-500">Password must be at least 8 chars</span>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">Confirm Password</label>
      <div class="kt-input" [ngClass]="{'border-red-500': (signUpForm.get('confirmPassword')?.touched && signUpForm.get('confirmPassword')?.invalid) || (signUpForm.hasError('mismatch') && signUpForm.get('confirmPassword')?.touched)}">
        <input formControlName="confirmPassword" placeholder="Re-enter Password" [type]="confirmPasswordVisible ? 'text' : 'password'"/>
        <button class="kt-btn kt-btn-sm kt-btn-ghost kt-btn-icon bg-transparent! -me-1.5"
                type="button" (click)="togglePasswordVisibility('confirm')">
          @if (!confirmPasswordVisible) {
            <span><i class="ki-filled ki-eye text-muted-foreground"></i></span>
          } @else {
            <span><i class="ki-filled ki-eye-slash text-muted-foreground"></i></span>
          }
        </button>
      </div>
      @if (signUpForm.hasError('mismatch') && signUpForm.get('confirmPassword')?.touched) {
        <span class="text-xs text-red-500">Passwords do not match</span>
      }
    </div>

    <label class="kt-checkbox-group">
      <input class="kt-checkbox kt-checkbox-sm" formControlName="acceptTerms" type="checkbox"/>
      <span class="kt-checkbox-label">
        I accept <a class="text-sm link" href="javascript:void(0)">Terms & Conditions</a>
      </span>
    </label>

    <button [disabled]="isLoading" class="kt-btn kt-btn-primary flex justify-center grow" type="submit">
      @if (!isLoading) {
        <span>Sign up</span>
      } @else {
        <span>Verifying...</span>
      }
    </button>
  </form>
</div>
